'use client';

import React, { useState } from 'react';
import { Toaster } from 'sonner';
import SignUpTypeToggle from './SignUpTypeToggle';
import BandForm from './BandForm';
import SoloForm from './SoloForm';
import ConfirmationScreen from './ConfirmationScreen';
import type { Song } from '@/lib/songs';

type BandConfirmation = { type: 'band'; bandName: string; song: Song };
type SoloConfirmation = { type: 'solo'; musicianName: string; instrument: string; songs: Song[] };
type Confirmation = BandConfirmation | SoloConfirmation;

export default function SignUpFormContainer() {
  const [signUpType, setSignUpType] = useState<'band' | 'solo'>('band');
  const [confirmation, setConfirmation] = useState<Confirmation | null>(null);

  function handleTypeChange(t: 'band' | 'solo') {
    setSignUpType(t);
    setConfirmation(null);
  }

  return (
    <>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#1a1a1a',
            border: '1px solid #2a2a2a',
            color: '#f0ece3',
            fontFamily: 'DM Sans, sans-serif',
          },
        }}
      />

      <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6 md:p-8 shadow-card w-full">
        {confirmation ? (
          <ConfirmationScreen data={confirmation} onReset={() => setConfirmation(null)} />
        ) : (
          <>
            <SignUpTypeToggle value={signUpType} onChange={handleTypeChange} />

            {signUpType === 'band' ? (
              <BandForm
                onSuccess={(d) =>
                  setConfirmation({ type: 'band', bandName: d.bandName, song: d.song })
                }
              />
            ) : (
              <SoloForm
                onSuccess={(d) =>
                  setConfirmation({
                    type: 'solo',
                    musicianName: d.musicianName,
                    instrument: d.instrument,
                    songs: d.songs,
                  })
                }
              />
            )}
          </>
        )}
      </div>
    </>
  );
}